"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _FeuerwehrNotification = _interopRequireDefault(require("../model/FeuerwehrNotification"));
var _GlobalNotification = _interopRequireDefault(require("../model/GlobalNotification"));
var _GlobalNotificationCreate = _interopRequireDefault(require("../model/GlobalNotificationCreate"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _Nutzer = _interopRequireDefault(require("../model/Nutzer"));
var _Verwalter = _interopRequireDefault(require("../model/Verwalter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Nutzer service.
* @module api/NutzerApi
* @version 0.0.1
*/
class NutzerApi {
  /**
  * Constructs a new NutzerApi. 
  * @alias module:api/NutzerApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createNutzerUserPost operation.
   * @callback module:api/NutzerApi~createNutzerUserPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Nutzer} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Nutzer
   * Legt einen Nutzer im System an und einen deaktivierten Nutzer bei Firebase.
   * @param {String} mail 
   * @param {String} vorname 
   * @param {String} nachname 
   * @param {String} telefon 
   * @param {String} feuerwehrId 
   * @param {String} password 
   * @param {module:api/NutzerApi~createNutzerUserPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Nutzer}
   */
  createNutzerUserPost(mail, vorname, nachname, telefon, feuerwehrId, password, callback) {
    let postBody = null;
    // verify the required parameter 'mail' is set
    if (mail === undefined || mail === null) {
      throw new Error("Missing the required parameter 'mail' when calling createNutzerUserPost");
    }
    // verify the required parameter 'vorname' is set
    if (vorname === undefined || vorname === null) {
      throw new Error("Missing the required parameter 'vorname' when calling createNutzerUserPost");
    }
    // verify the required parameter 'nachname' is set
    if (nachname === undefined || nachname === null) {
      throw new Error("Missing the required parameter 'nachname' when calling createNutzerUserPost");
    }
    // verify the required parameter 'telefon' is set
    if (telefon === undefined || telefon === null) {
      throw new Error("Missing the required parameter 'telefon' when calling createNutzerUserPost");
    }
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling createNutzerUserPost");
    }
    // verify the required parameter 'password' is set
    if (password === undefined || password === null) {
      throw new Error("Missing the required parameter 'password' when calling createNutzerUserPost");
    }
    let pathParams = {};
    let queryParams = {
      'mail': mail,
      'vorname': vorname,
      'nachname': nachname,
      'telefon': telefon,
      'feuerwehr_id': feuerwehrId,
      'password': password
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Nutzer.default;
    return this.apiClient.callApi('/user/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the createVerwalterUserVerwalterPost operation.
   * @callback module:api/NutzerApi~createVerwalterUserVerwalterPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Verwalter} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Verwalter
   * Legt einen Verwalter im System an.
   * @param {String} nutzerId 
   * @param {Number} feuerwehrId 
   * @param {module:api/NutzerApi~createVerwalterUserVerwalterPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Verwalter}
   */
  createVerwalterUserVerwalterPost(nutzerId, feuerwehrId, callback) {
    let postBody = null;
    // verify the required parameter 'nutzerId' is set
    if (nutzerId === undefined || nutzerId === null) {
      throw new Error("Missing the required parameter 'nutzerId' when calling createVerwalterUserVerwalterPost");
    }
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling createVerwalterUserVerwalterPost");
    }
    let pathParams = {};
    let queryParams = {
      'nutzer_id': nutzerId,
      'feuerwehr_id': feuerwehrId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Verwalter.default;
    return this.apiClient.callApi('/user/verwalter', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteNutzerUserNutzerIdDelete operation.
   * @callback module:api/NutzerApi~deleteNutzerUserNutzerIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Nutzer
   * @param {String} nutzerId 
   * @param {module:api/NutzerApi~deleteNutzerUserNutzerIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteNutzerUserNutzerIdDelete(nutzerId, callback) {
    let postBody = null;
    // verify the required parameter 'nutzerId' is set
    if (nutzerId === undefined || nutzerId === null) {
      throw new Error("Missing the required parameter 'nutzerId' when calling deleteNutzerUserNutzerIdDelete");
    }
    let pathParams = {
      'nutzer_id': nutzerId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/user/{nutzer_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteVerwalterUserVerwalterVerwalterIdDelete operation.
   * @callback module:api/NutzerApi~deleteVerwalterUserVerwalterVerwalterIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Verwalter
   * @param {String} verwalterId 
   * @param {Number} feuerwehrId 
   * @param {module:api/NutzerApi~deleteVerwalterUserVerwalterVerwalterIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteVerwalterUserVerwalterVerwalterIdDelete(verwalterId, feuerwehrId, callback) {
    let postBody = null;
    // verify the required parameter 'verwalterId' is set
    if (verwalterId === undefined || verwalterId === null) {
      throw new Error("Missing the required parameter 'verwalterId' when calling deleteVerwalterUserVerwalterVerwalterIdDelete");
    }
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling deleteVerwalterUserVerwalterVerwalterIdDelete");
    }
    let pathParams = {
      'verwalter_id': verwalterId
    };
    let queryParams = {
      'feuerwehr_id': feuerwehrId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/user/verwalter/{verwalter_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getCurrentNutzerUserGet operation.
   * @callback module:api/NutzerApi~getCurrentNutzerUserGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Nutzer} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Current Nutzer
   * Holt den aktuell angemeldeten Nutzer.
   * @param {module:api/NutzerApi~getCurrentNutzerUserGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Nutzer}
   */
  getCurrentNutzerUserGet(callback) {
    let postBody = null;
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Nutzer.default;
    return this.apiClient.callApi('/user', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getFeuerwehrNotificationsUserFeuerwehrsubscriptionGet operation.
   * @callback module:api/NutzerApi~getFeuerwehrNotificationsUserFeuerwehrsubscriptionGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/FeuerwehrNotification>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Feuerwehr Notifications
   * Holt die Liste der Feuerwehr Benachrichtigungen eines Nutzers.
   * @param {Object} opts Optional parameters
   * @param {Number} [feuerwehrId = 0)] Feuerwehr ID um die Liste einzugrenzen.
   * @param {module:api/NutzerApi~getFeuerwehrNotificationsUserFeuerwehrsubscriptionGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/FeuerwehrNotification>}
   */
  getFeuerwehrNotificationsUserFeuerwehrsubscriptionGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'feuerwehr_id': opts['feuerwehrId']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_FeuerwehrNotification.default];
    return this.apiClient.callApi('/user/feuerwehrsubscription', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getGlobalNotificationsUserSubscriptionGet operation.
   * @callback module:api/NutzerApi~getGlobalNotificationsUserSubscriptionGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/GlobalNotificationCreate} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Global Notifications
   * Holt die Liste der globalen Benachrichtigungen eines Nutzers.
   * @param {module:api/NutzerApi~getGlobalNotificationsUserSubscriptionGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/GlobalNotificationCreate}
   */
  getGlobalNotificationsUserSubscriptionGet(callback) {
    let postBody = null;
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _GlobalNotificationCreate.default;
    return this.apiClient.callApi('/user/subscription', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getUsersUsersGet operation.
   * @callback module:api/NutzerApi~getUsersUsersGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Nutzer>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Users
   * Holt alle Nutzer im System.
   * @param {Object} opts Optional parameters
   * @param {String} [searchString = '')] Suchstring um die Liste einzugrenzen.
   * @param {Number} [feuerwehr = 0)] Feuerwehr ID um die Liste einzugrenzen.
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {module:api/NutzerApi~getUsersUsersGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Nutzer>}
   */
  getUsersUsersGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'searchString': opts['searchString'],
      'feuerwehr': opts['feuerwehr'],
      'skip': opts['skip'],
      'limit': opts['limit']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Nutzer.default];
    return this.apiClient.callApi('/users', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getVerwalterUserVerwalterGet operation.
   * @callback module:api/NutzerApi~getVerwalterUserVerwalterGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Verwalter>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Verwalter
   * Holt alle Verwalter im System.
   * @param {String} nutzerId 
   * @param {module:api/NutzerApi~getVerwalterUserVerwalterGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Verwalter>}
   */
  getVerwalterUserVerwalterGet(nutzerId, callback) {
    let postBody = null;
    // verify the required parameter 'nutzerId' is set
    if (nutzerId === undefined || nutzerId === null) {
      throw new Error("Missing the required parameter 'nutzerId' when calling getVerwalterUserVerwalterGet");
    }
    let pathParams = {};
    let queryParams = {
      'nutzer_id': nutzerId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Verwalter.default];
    return this.apiClient.callApi('/user/verwalter', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the putNutzerUserPut operation.
   * @callback module:api/NutzerApi~putNutzerUserPutCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Nutzer} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Put Nutzer
   * Aktualisiert die Daten eines Nutzers.
   * @param {String} vorname 
   * @param {String} nachname 
   * @param {String} telefon 
   * @param {Number} feuerwehrId 
   * @param {module:api/NutzerApi~putNutzerUserPutCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Nutzer}
   */
  putNutzerUserPut(vorname, nachname, telefon, feuerwehrId, callback) {
    let postBody = null;
    // verify the required parameter 'vorname' is set
    if (vorname === undefined || vorname === null) {
      throw new Error("Missing the required parameter 'vorname' when calling putNutzerUserPut");
    }
    // verify the required parameter 'nachname' is set
    if (nachname === undefined || nachname === null) {
      throw new Error("Missing the required parameter 'nachname' when calling putNutzerUserPut");
    }
    // verify the required parameter 'telefon' is set
    if (telefon === undefined || telefon === null) {
      throw new Error("Missing the required parameter 'telefon' when calling putNutzerUserPut");
    }
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling putNutzerUserPut");
    }
    let pathParams = {};
    let queryParams = {
      'vorname': vorname,
      'nachname': nachname,
      'telefon': telefon,
      'feuerwehr_id': feuerwehrId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Nutzer.default;
    return this.apiClient.callApi('/user', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the subscribeToFeuerwehrUserSubscribeFeuerwehrIdPost operation.
   * @callback module:api/NutzerApi~subscribeToFeuerwehrUserSubscribeFeuerwehrIdPostCallback
   * @param {String} error Error message, if any.
   * @param {Boolean} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Subscribe To Feuerwehr
   * Toggled das Abonnement einer Feuerwehr.
   * @param {Number} feuerwehrId 
   * @param {module:api/NutzerApi~subscribeToFeuerwehrUserSubscribeFeuerwehrIdPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Boolean}
   */
  subscribeToFeuerwehrUserSubscribeFeuerwehrIdPost(feuerwehrId, callback) {
    let postBody = null;
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling subscribeToFeuerwehrUserSubscribeFeuerwehrIdPost");
    }
    let pathParams = {
      'feuerwehr_id': feuerwehrId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = 'Boolean';
    return this.apiClient.callApi('/user/subscribe/{feuerwehr_id}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the subscribeToPushUserSubscribePost operation.
   * @callback module:api/NutzerApi~subscribeToPushUserSubscribePostCallback
   * @param {String} error Error message, if any.
   * @param {String} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Subscribe To Push
   * Speichert/Updated den Key des Nutzers um Push-Nachrichten zu erhalten.
   * @param {String} key 
   * @param {module:api/NutzerApi~subscribeToPushUserSubscribePostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link String}
   */
  subscribeToPushUserSubscribePost(key, callback) {
    let postBody = null;
    // verify the required parameter 'key' is set
    if (key === undefined || key === null) {
      throw new Error("Missing the required parameter 'key' when calling subscribeToPushUserSubscribePost");
    }
    let pathParams = {};
    let queryParams = {
      'key': key
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = 'String';
    return this.apiClient.callApi('/user/subscribe', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateGlobalNotificationsUserSubscriptionPatch operation.
   * @callback module:api/NutzerApi~updateGlobalNotificationsUserSubscriptionPatchCallback
   * @param {String} error Error message, if any.
   * @param {module:model/GlobalNotification} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Global Notifications
   * Aktualisiert die Liste der globalen Benachrichtigungen eines Nutzers.
   * @param {module:model/GlobalNotificationCreate} globalNotificationCreate 
   * @param {module:api/NutzerApi~updateGlobalNotificationsUserSubscriptionPatchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/GlobalNotification}
   */
  updateGlobalNotificationsUserSubscriptionPatch(globalNotificationCreate, callback) {
    let postBody = globalNotificationCreate;
    // verify the required parameter 'globalNotificationCreate' is set
    if (globalNotificationCreate === undefined || globalNotificationCreate === null) {
      throw new Error("Missing the required parameter 'globalNotificationCreate' when calling updateGlobalNotificationsUserSubscriptionPatch");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _GlobalNotification.default;
    return this.apiClient.callApi('/user/subscription', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateNutzerUserNutzerIdPatch operation.
   * @callback module:api/NutzerApi~updateNutzerUserNutzerIdPatchCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Nutzer} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Nutzer
   * @param {String} nutzerId 
   * @param {module:model/Nutzer} nutzer 
   * @param {module:api/NutzerApi~updateNutzerUserNutzerIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Nutzer}
   */
  updateNutzerUserNutzerIdPatch(nutzerId, nutzer, callback) {
    let postBody = nutzer;
    // verify the required parameter 'nutzerId' is set
    if (nutzerId === undefined || nutzerId === null) {
      throw new Error("Missing the required parameter 'nutzerId' when calling updateNutzerUserNutzerIdPatch");
    }
    // verify the required parameter 'nutzer' is set
    if (nutzer === undefined || nutzer === null) {
      throw new Error("Missing the required parameter 'nutzer' when calling updateNutzerUserNutzerIdPatch");
    }
    let pathParams = {
      'nutzer_id': nutzerId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Nutzer.default;
    return this.apiClient.callApi('/user/{nutzer_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = NutzerApi;